export function isError(err: Error | unknown): err is Error {
  return (err as Error).message !== undefined;
}

const PASSWORD_REQUIREMENTS_PATTERN =
  /Password must contain|8 to 20 characters|uppercase and lowercase letters|special characters and numbers/i;

export const buildErrorMessage = (
  err: Error | unknown,
  defaultMessage = "Erro ao executar ação"
) => {
  const messagesArray: string[] = isError(err)
    ? err.response?.data?.messages || [err.message]
    : [defaultMessage];

  const message = messagesArray[0] ?? defaultMessage;

  if (message && PASSWORD_REQUIREMENTS_PATTERN.test(message)) {
    return defaultMessage;
  }

  return message;
};
